import useFormatDate from "ui/common/hooks/useFormatDate/useFormatDate";
import type { Locale } from "common/models/settings/Settings";
import useLocale from "ui/locale/hooks/useLocale";

interface LocalePositions {
    day: number;
    month: number;
    year: number;
}

export type DateLocalePositions = Record<Locale, LocalePositions>;

const DATE_LOCALE_POSITIIONS: DateLocalePositions = {
    en: {
        day: 1,
        month: 0,
        year: 2,
    },
    es: {
        day: 0,
        month: 1,
        year: 2,
    },
};

/**
 * This hooks is in charge of formatting from the locale date format to a
 * valid date object and vice versa.
 */
export default function useFormatDateFilterDate() {
    const formatDate = useFormatDate();
    const locale = useLocale();

    function parseDate(date: string): Date {
        const dateParts = date.split("/");
        const { day, year, month } = DATE_LOCALE_POSITIIONS[locale];
        return new Date(Number(dateParts[year]), Number(dateParts[month]) - 1, Number(dateParts[day]));
    }

    return {
        formatDate,
        parseDate,
        locale,
    };
}
